var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnlimitedCustomisations(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8574 12.5919C22.8261 13.6253 21.5115 14.3297 20.0798 14.616C18.6481 14.9023 17.1637 14.7577 15.8142 14.2004L7.02358 24.7936C5.41494 26.4021 2.81512 26.4021 1.20648 24.7936C-0.40216 23.1852 -0.40216 20.5856 1.20648 18.9933L11.8008 10.1873C10.6958 7.50649 11.232 4.32202 13.4094 2.14488C15.4893 0.0652185 18.4791 -0.48719 21.0789 0.42266L16.3829 5.11813L20.9651 9.69988L25.6123 5.0369C26.4735 7.60397 25.9048 10.5447 23.8574 12.5919ZM2.94511 23.0552C3.59507 23.6888 4.635 23.6888 5.2687 23.0552C5.91866 22.4053 5.91866 21.3655 5.2687 20.7318C4.635 20.0819 3.59507 20.0819 2.94511 20.7318C2.64046 21.0417 2.46974 21.4589 2.46974 21.8935C2.46974 22.3281 2.64046 22.7452 2.94511 23.0552Z",
    fill: "url(#paint0_linear_2002_1354)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2002_1354",
    x1: -0.606414,
    y1: 0.0000156028,
    x2: 27.9944,
    y2: 0.710832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0279144,
    stopColor: "#A451D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.948784,
    stopColor: "#603DB1"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlimitedCustomisations);
export default __webpack_public_path__ + "static/media/unlimited-customisations.b1f7913d8186c7831e9453f9844c83ff.svg";
export { ForwardRef as ReactComponent };